(function(global) {
	"use strict";

	const app = new Vue({
		el: "#search-app",
	});
	const searchApp = app.$refs.view

	// 銭湯データを読み込む
	$.ajax({
		url: "/search/shops.json",
		type: "GET",
		dataType: "json"

	}).done(result => {
		store.error = null;
		store.baths.splice(0, store.baths.length, ...result.items);
		global.searchAppInitParams();

	}).fail(err => {
		store.error = "銭湯情報を読み込めません";
	});

	global.searchApp = searchApp;
})(window);
